/** Godot's `is_visible_in_tree()` over three's scene graph, which draws nothing under a hidden ancestor. */
/** Whether `object` and each of its ancestors are visible. */
export function visibleInTree(object) {
    for (let o = object; o; o = o.parent) {
        if (!o.visible)
            return false;
    }
    return true;
}
//# sourceMappingURL=visibleInTree.js.map